// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const CursorLg = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M7.8916 20.0264C6.8316 21.4064 4.6276 20.6864 4.5856 18.9474L4.2506 5.14243C4.2146 3.68243 5.8076 2.76243 7.0546 3.52343L18.8426 10.7154C20.3276 11.6214 19.8486 13.8914 18.1236 14.1184L12.5426 14.8564C12.3027 14.8879 12.0714 14.9664 11.8619 15.0873C11.6524 15.2083 11.4688 15.3694 11.3216 15.5614L7.8916 20.0264Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
    </svg>
);
